export const copySupportInformation = ({
  teamUri,
  formUri,
  userUri,
  submissionUri,
}: {
  formUri: string;
  teamUri?: string;
  userUri?: string;
  submissionUri?: string;
}) => {
  navigator.clipboard
    .writeText(
      JSON.stringify({
        teamUri,
        userUri,
        formUri,
        submissionUri,
        timestamp: new Date().toISOString(),
      }),
    )
    .catch(console.error);
};
